import React from 'react';

import Header from './components/Header'
import Footer from './components/Footer'
import Hero from './components/Hero'
import Banner from './components/Banner'
import Pricing from './components/Pricing'
import Contact from './components/Contact'
import Testinomilas from './components/Testinomilas'

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Banner />
      <Contact />
      <Testinomilas />
      <Pricing />
      <Footer />
      
    </div>
  );
}

export default App;
